import React from 'react'
import type { TestState } from '@merels/web/deps/debug/positions/positions'

export interface StateCardProps {
  state: TestState
  isSelected: boolean
  showChevron?: boolean
  clickable?: boolean
  onChevronClick?: (e: React.MouseEvent) => void
  chevronDirection?: 'up' | 'down'
  onClick?: () => void
}

export function StateCard({
  state,
  isSelected,
  showChevron = false,
  clickable = true,
  onChevronClick,
  chevronDirection = 'down',
  onClick
}: StateCardProps) {
  return (
    <div 
      className={`p-2 transition-colors ${
        clickable ? 'cursor-pointer bg-muted-bg/50 hover:bg-accent/20' : ''
      } ${
        isSelected ? 'bg-accent/10 border-l-2 border-l-primary' : ''
      }`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <div className="text-xs text-muted font-mono mb-1">
            {state.name}
          </div>
          <div className="text-sm font-medium mb-1">
            {state.displayName}
          </div>
          {state.description && (
            <div className="text-xs text-muted">
              {state.description}
            </div>
          )}
        </div>
        {showChevron && (
          <div className="flex items-center gap-2 flex-shrink-0">
            <button
              onClick={onChevronClick}
              className="text-xs text-muted hover:text-primary px-1"
              data-testid={`chevron-${state.name}`}
              type="button"
            >
              {chevronDirection === 'down' ? '▼' : '▶'}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

